'use strict'
import moment from 'moment'
import _ from 'lodash'
import magazzino from '@/services/magazzinoService.js'
import documenti from '@/services/documentiService.js'
import scontrini from '@/services/scontriniService.js'
import excelService from '@/services/excelService'
import { downloadTxt } from '@/components/helpers'

async function esportaDaModello(modello, periodo) {
  var dati
  var ids
  switch(modello.tipoDati) {
    case 'scontrini':
      ({ dati, ids } = await esportaScontrini(modello, periodo))
    case 'fatture':
      break
    case 'ordini':
      break
    default:
      break
  }
  return {
    dati,
    tipo: modello.tipoDati,
    ids
  }
}

async function generaFile(modello, dati, document) {
  var config
  switch(modello.file.tipo) {
    case 'dat':
      switch (modello.file.destinazione) {
        case 'file':
          config = { ...modello.file, nomeFile: parseNomeFile(modello) }
          return await documenti.salvaFileLocale(dati, config)          
        case 'ftp':
          config = { ...modello.ftp, nomeFile: parseNomeFile(modello) }
          return await documenti.inviaFtp(dati, config)
        case 'download':
          return await downloadTxt(document, parseNomeFile(modello), dati)
        default:
          break
      }
      break
      case 'csv':
        const separatore = modello.file.separatore
        var datiCsv = await excelService.creaExcelFromArrayToMemory(dati, separatore)
        switch (modello.file.destinazione) {
          case 'file':
            config = { ...modello.file, nomeFile: parseNomeFile(modello) }
            return await documenti.salvaFileLocale(datiCsv, config)          
          case 'ftp':
            config = { ...modello.ftp, nomeFile: parseNomeFile(modello) }
            return await documenti.inviaFtp(datiCsv, config)
          case 'download':
            return await downloadTxt(document, parseNomeFile(modello), datiCsv)
          default:
            break
        }
        break      
/*     case 'csv':
      // TODO: sistemare per invio su FTP
      const separatore = modello.file.separatore
      await excelService.creaExcelFromArray(dati, parseNomeFile(modello), separatore)
      break */
    default:
      break
  }
}

const parseNomeFile = (modello) => {
  let nomeFile = modello.file.nomeFile
  nomeFile = nomeFile.replace('#yyyy#', String(moment().year()))
  nomeFile = nomeFile.replace('#yy#', String(moment().year()).substring(2))
  nomeFile = nomeFile.replace('#mm#', String(moment().month() + 1).padStart(2, '0'))
  nomeFile = nomeFile.replace('#dd#', String(moment().date()).padStart(2, '0'))
  return nomeFile
}

async function esportaScontrini(modello, periodo) {
  const payload = { codiceModello: modello.codice, filtri: modello.filtri }
  const datiRaw = await magazzino.scontriniFlatEsportazione(periodo, payload)
  const ids = datiRaw.map(x => x.id)
  var dati
  switch (_.get(modello, 'file.formato')) {
    case 'lunghezzaFissa':
      dati = mapDatiModelloLunghezzaFissa(modello, datiRaw)
      dati = dati.join(modello.file.newline || '\r\n') + (modello.file.newline || '\r\n')
      break
    case 'delimitato':
      dati = mapDatiModelloDelimitato(modello, datiRaw)
      break
    default:
      break
  }
  return { dati, ids }
}

async function marcaTrasferiti(tipo, codiceModello, ids) {
  switch(tipo) {
    case 'scontrini':
      await scontrini.scambioDatiMarcaTrasferiti(codiceModello, ids)
    case 'fatture':
      break
    case 'ordini':
      break
    default:
      break
  }
  
}

// TODO: Accorpare le funzioni di mappatura e separare solo l'ultimo livello
// **************************************************************************************************************************
// **************************************************************************************************************************
// *******************************        Map dati a lunghezza fissa    *****************************************************
// **************************************************************************************************************************
// **************************************************************************************************************************

const mapDatiModelloLunghezzaFissa = (modello, datiRaw) => {
  var dati
  switch (_.get(modello, 'file.contenuto')) {
    case 'testata':
      break
    case 'dettaglio':
      break
    case 'misto':
      dati = mapDatiModelloLunghezzaFissaMisto(modello, datiRaw)
      break
    default:
      break
  }
  return dati  
}

const mapDatiModelloLunghezzaFissaMisto = (modello, datiRaw) => {
  const campoVerificaTestata = modello.misto.campoTestata // Campo su cui verifica nuova testata
  let oldTestata = ''
  let dati = []
  for (let d of datiRaw) {
    if (_.get(d, campoVerificaTestata) !== oldTestata) {
      oldTestata = _.get(d, campoVerificaTestata)
      // Crea testata
      const testata = mapDatiLunghezzaFissa(modello.testata, d)
      dati.push(testata)
    }
    // crea Dettaglio
    const dettaglio = mapDatiLunghezzaFissa(modello.dettaglio, d)
    dati.push(dettaglio)
  }
  return dati
}

const mapDatiLunghezzaFissa = (modello, datiRaw) => {
  let riga = ''
  for (let m of modello) {
    let valore = m.fisso ? m.fisso : (m.sorgente ? _.get(datiRaw, m.sorgente, '') : '')
    if (m.uppercase) {
      valore = valore.toUpperCase()
    }
    if (m.lowercase) {
      valore = valore.toLowerCase()
    }    
    if (m.tipo === 'A') {
      if (m.allineamento === 'S') {
        valore = valore.padEnd(m.len || valore.length, ' ')
      } else {
        valore = valore.padStart(m.len || valore.length, ' ')
      }
      if (m.maxChar) {
        valore = valore.substring(0, parseInt(m.maxChar))
      }
    } else if (m.tipo === 'N') {
      if (valore === '') {
        valore = 0
      }
      if (m.decimali) {
        valore = valore.toFixed(m.decimali)
      }
      if (m.virgola) {
        if (m.virgola === 'V') {
          valore = (parseFloat(valore) * (Math.pow(10, m.decimali))).toFixed(0)
        } else {
          valore = String(valore).replace('.', m.virgola)
        }
      }
      if (m.segno === 'P') {
        valore = `${valore >= 0 ? '+' : '-'}${String(valore).padStart((m.len || valore.length)-1, '0')}` 
      } else if (m.segno === 'D') {
        valore = `${String(valore)}${valore >= 0 ? '+' : '-'}`
      }      
      if (m.allineamento === 'S') {
        valore = String(valore).padEnd(m.len || valore.length, '0')
      } else {
        valore = String(valore).padStart(m.len || valore.length, '0')
      }
    } else if (m.tipo === 'D' && !m.fisso) {
      if (valore === '') {
        valore = '00000000' // TODO: Verificare. Parametro ifEmpty ??
      } else {
        if (m.allineamento === 'G') {
          if (m.len === 8) {
            valore = moment(valore).format('DDMMYYYY')
          } else if (m.len === 10) {
            valore = moment(valore).format('DD/MM/YYYY')
          }
        } else if (m.allineamento === 'A') {
          valore = moment(valore).format('YYYYMMDD')
        }
      }
      valore = valore.padStart(m.len || valore.length, ' ')
    } else {
      console.log('MapDatiLunghezzaFissa: tipo non valido', m, datiRaw)
    }
    riga = riga + String(valore)
  }
  return riga
}

// **************************************************************************************************************************
// **************************************************************************************************************************
// *******************************           Map dati delimitati        *****************************************************
// **************************************************************************************************************************
// **************************************************************************************************************************

const mapDatiModelloDelimitato = (modello, datiRaw) => {
  var dati
  switch (_.get(modello, 'file.contenuto')) {
    case 'testata':
      break
    case 'dettaglio':
      break
    case 'misto':
      dati = mapDatiModelloDelimitatoMisto(modello, datiRaw)
      break
    default:
      break
  }
  return dati
}

const mapDatiModelloDelimitatoMisto = (modello, datiRaw) => {
  const campoVerificaTestata = modello.misto.campoTestata // Campo su cui verifica nuova testata
  // const delimitatore = modello.delimitatore || ';'
  let oldTestata = ''
  let dati = []
  for (let d of datiRaw) {
    if (_.get(d, campoVerificaTestata) !== oldTestata) {
      oldTestata = _.get(d, campoVerificaTestata)
      // Crea testata
      const testata = mapDatiDelimitato(modello.testata, d)
      dati.push(testata)
    }
    // crea Dettaglio
    const dettaglio = mapDatiDelimitato(modello.dettaglio, d)
    dati.push(dettaglio)
  }
  return dati
}

const mapDatiDelimitato = (modello, datiRaw) => {
  let riga = {}
  let numCampo = 0
  for (let m of modello) {
    let valore = m.fisso ? m.fisso : (m.sorgente ? _.get(datiRaw, m.sorgente, '') : '')
    if (m.uppercase) {
      valore = valore.toUpperCase()
    }
    if (m.lowercase) {
      valore = valore.toLowerCase()
    }      
    if (m.tipo === 'A') {
      if (m.allineamento === 'S') {
        valore = valore.padEnd(m.len || valore.length, ' ')
      } else {
        valore = valore.padStart(m.len || valore.length, ' ')
      }
      if (m.maxChar) {
        valore = valore.substring(0, parseInt(m.maxChar))
      }      
    } else if (m.tipo === 'N') {
      if (valore === '') {
        valore = 0
      }
      if (m.decimali) {
        valore = valore.toFixed(m.decimali)
      }
      if (m.virgola) {
        if (m.virgola === 'V') {
          valore = (parseFloat(valore) * (Math.pow(10, m.decimali))).toFixed(0)
        } else {
          valore = String(valore).replace('.', m.virgola)
        }
      }
      if (m.segno === 'P') {
        valore = `${valore >= 0 ? '+' : '-'}${String(valore).padStart((m.len || valore.length)-1, '0')}` 
      } else if (m.segno === 'D') {
        valore = `${String(valore)}${valore >= 0 ? '+' : '-'}`
      }      
      if (m.allineamento === 'S') {
        valore = String(valore).padEnd(m.len || valore.length, '0')
      } else {
        valore = String(valore).padStart(m.len || valore.length, '0')
      }
    } else if (m.tipo === 'D' && !m.fisso) {
      if (valore === '') {
        valore = '00000000' // TODO: Verificare. Parametro ifEmpty ??
      } else {
        if (m.allineamento === 'G') {
          if (m.len === 8) {
            valore = moment(valore).format('DDMMYYYY')
          } else if (m.len === 10) {
            valore = moment(valore).format('DD/MM/YYYY')
          }
        } else if (m.allineamento === 'A') {
          valore = moment(valore).format('YYYYMMDD')
        }
      }
      valore = valore.padStart(m.len || valore.length, ' ')
    }
    // riga[m.codice] = valore
    riga[`ca${String(numCampo).padStart(2, '0')}`] = valore
    numCampo ++

  }
  return riga  
}


// **************************  WEBSERVICE  **************************************************
// TODO: Completare. Al monento fatto solo per sellout. Non passo parametri perchè il servizio chiamato gestisce autonomamente

async function callWebservice(modello, filtro) {
  const url = _.get(modello, 'webservice.url')
  const tipoOperazione = _.get(modello, 'webservice.tipoOperazione') || 'GET'
  let result = 'Nessun servizio'
  if (url) {
    if (tipoOperazione === 'POST') {
      result = await callPost(url) // eventuale payload ...
    } else {
      result = await callGet(url)
    }
  }
  return result
}

async function callGet(url) {
  try {
    const response = await fetch(url)
    return await response.json()
  } catch (error) {
    return null
  }
}

async function callPost(url, payload) {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    return await response.json()
  } catch (error) {
    return null
  }
}

export default {
  esportaDaModello,
  generaFile,
  marcaTrasferiti,
  callWebservice
}
